import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  IconButton,
  Typography,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Modal,
  Tooltip,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import CloseIcon from "@mui/icons-material/Close";
import {
  settingsModal_bg_color_dm,
} from "../../../../../constants/colors";
import GetCountryFlagByName from "../../../settingBar/VideoGenSettings/GetCountryFlagByName";
import SearchIcon from "@mui/icons-material/Search";
import { getBlockNumberData } from "../../../../../contexts/WorkspaceUtils";
import CommonToast from "../../../../Common_Components/CommonToast";
import BlockListModal from "./BlockListModal";
import { useWorkspace } from "../../../../../contexts/WorkspaceContext";

const Defaultoption = [
  {
    label: "Edit",
    icon: <EditIcon style={{ color: "white" }} />,
    onClick: () => console.log("Edit"),
  },
  {
    label: "Delete",
    icon: <DeleteIcon style={{ color: "white" }} />,
    onClick: () => console.log("Delete"),
  },
];

const ViewTranscriptModal = ({
  showViewTranscriptModal,
  HandleViewTranscriptModalCloseClick,
  Content,
  Title
}) => {
  const theme = localStorage.getItem("theme");
  return (
    <div>
      <Modal
        open={showViewTranscriptModal}
        onClose={HandleViewTranscriptModalCloseClick}
        aria-labelledby="audio-settings-title"
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            width: "480px",
            backgroundColor: "background.paper",
            boxShadow: 24,
            display: "flex",
            flexDirection: "column",
            bgcolor: theme === "dark" ? settingsModal_bg_color_dm : "",
            borderRadius: "8px",
            maxHeight:"80vh",
            overflow: "hidden",
          }}
        >
          <Typography
            id="audio-settings-title"
            variant="h6"
            component="h2"
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              height: "68px",
              // mb: 2,
              borderBottom: `1px solid ${
                theme === "dark" ? "rgba(255, 255, 255, 0.20)" : ""
              }`,
              padding: "20px",
              font: "Inter",
            }}
            style={{
              fontSize: "20px",
              fontWeight: "600",
              color: theme === "dark" ? "#FFFFFF" : "",
            }}
          >
           {Title ? Title : "Call transcript"}
            <IconButton
              aria-label="close"
              onClick={HandleViewTranscriptModalCloseClick}
              sx={{
                // color: (theme) => theme.palette.grey[500],
                color: "#FFFFFF",
              }}
            >
              <CloseIcon />
            </IconButton>
          </Typography>
          <Box sx={{ padding: "20px" }}>
            <Box
              sx={{
                border: "1px solid rgba(255, 255, 255, 0.20)",
                borderRadius: "8px",
                padding: "20px",
                overflowY:"auto",
                maxHeight: "calc(80vh - 108px)",
              }}
            >
              <Typography
                sx={{
                  fontFamily: "Inter",
                  fontStyle: "normal",
                  fontSize: "16px",
                  fontWeight: 400,
                  lineHeight: "20px",
                  whiteSpace: "pre-wrap",
                }}
              >
                {/* Agent: Hello! <br />
                User: Thanks for <br />
                Agent: This is <br />
                User: the call. <br />
                Agent: You're <br />
                User: Configure your number's voice URL To change this message,
                let us know. If we can help you in any way during your
                development */}
                {/* {activeUserObject?.transcript} */}
                {Content}
              </Typography>
            </Box>
          </Box>
        </Box>
      </Modal>
    </div>
  );
};



const CommonMoreActionOptionModal = ({ showModal, setShowModal, options, setOpenDeleteConformationModal, openEditedModal, setActiveUserObject, activeUserObject }) => {
  const [extraOptions, setExtraOptions] = useState();
  const [showViewTranscriptModal, setShowViewTranscriptModal] = useState(null);
  const [showBlockListModal, setShowBlockListModal] = useState(null);
  const [open, setOpen] = useState(false);
  const [content, setContent] = useState("");
  const [iconType, setIconType] = useState("success");
  const {setShowVoiceCallModal } = useWorkspace ()
  const [showContent, setShowContent] = useState()
  const [title, setTitle] = useState("View transcript")
  

  const HandleViewTranscriptModalCloseClick = () => {
    setShowViewTranscriptModal(false);
  };

  const HandleBlockListModalCloseClick = () => {
    setShowBlockListModal(false);
  };

  useEffect(() => {
    if (options) {
      setExtraOptions(options);
    } else {
      setExtraOptions(Defaultoption);
    }
  }, [options]);

  const handleClose = () => {
    setActiveUserObject(null)
    setShowModal(false);
  };

  const downloadAudio = (url) => {
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = '';
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
  };

  const HandleMoreOptionClick = (options) => {
    // console.log("options", options)
    if (options?.label === "View transcript") {
      setShowViewTranscriptModal(true);
      setShowModal(false)
      setShowContent(activeUserObject?.transcript)
      setTitle("View transcript")
    } else if (options?.label === "Download recording") {
      //add the download logic here 
        if (activeUserObject?.recording_url) {
          downloadAudio(activeUserObject?.recording_url);
        } else {
          console.error('No audio URL provided');
          alert("Download Option Selected");
          }
    } else if (options?.label === "Edit") {
      openEditedModal(true)
      setShowModal(false)
    } else if (options?.label === "Delete") {
      setOpenDeleteConformationModal(true)
      setShowModal(false)
    } else if (options?.label === "Blocklist") {
      setShowBlockListModal(true);
      setShowModal(false)
    } else if (options?.label === "Web call"){
      setOpen(true);
      setContent("Coming Soon")
      setIconType('success')
    }else if(options?.label === "Voice call"){
      setShowVoiceCallModal(true)
    }else if(options?.label === "View customer analysis"){
      setShowViewTranscriptModal(true);
      setShowModal(false)
      setShowContent(activeUserObject?.custom_analysis)
      setTitle("View customer analysis")
    }
  };

  const handleToastClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <Menu
        anchorEl={showModal}
        open={Boolean(showModal)}
        // open={moreoption}
        onClose={handleClose}
        PaperProps={{
          style: {
            backgroundColor: "#2F355F",
            color: "white",
            padding: "4px",
            borderRadius: "8px",
            marginTop: "10px",
            marginLeft: "0px",
            border: "1px solid rgba(255, 255, 255, 0.2)",
          },
        }}
        anchorOrigin={{
          vertical: "bottom", // Open from the top of the button
          horizontal: "right", // Align to the right
        }}
        transformOrigin={{
          vertical: "top", // The menu will "pop" up from the bottom
          horizontal: "center", // The menu will align to the right
        }}
      >
        {/* Menu Items */}

        {extraOptions?.map((option, index) => {
          return (
             <Tooltip
                                                            componentsProps={{
                                                                tooltip: {
                                                                    sx: {
                                                                        bgcolor: "#E6E0E9",
                                                                        color: "#17182C",
                                                                        fontFamily: "Inter",
                                                                        fontSize: "12px",
                                                                        fontWeight: 500,
                                                                        padding: "4px 8px 4px 8px",
                                                                        borderRadius: "4px",
                                                                        textAlign: "center",
                                                                    },
                                                                },
                                                            }}
                                                            title={
                                                                (activeUserObject?.type == "web_call" && option?.label=="Voice call")
                                                                ? `Agent type is phone call only`
                                                                : null}
                                                        >
            <MenuItem  
            // disabled={activeUserObject?.type == "web_call" && option?.label=="Voice call"}
              key={index}
              onClick={activeUserObject?.type == "web_call" && option?.label=="Voice call" ? null : () => HandleMoreOptionClick(option)}
              style={{ padding: "8px 8px", backgroundColor: "transparent", opacity : activeUserObject?.type == "web_call" && option?.label=="Voice call" ? 0.5 : 1 }}
            >
              <ListItemIcon>{option.icon}</ListItemIcon>
              <ListItemText primary={option?.label} />
            </MenuItem></Tooltip>
          );
        })}
      </Menu>
      <ViewTranscriptModal
        showViewTranscriptModal={showViewTranscriptModal}
        HandleViewTranscriptModalCloseClick={
          HandleViewTranscriptModalCloseClick
        }
        Content={showContent}
        Title={title}
      />
      {
      showBlockListModal &&
        <BlockListModal
          showBlockListModal={showBlockListModal}
          HandleBlockListModalCloseClick={HandleBlockListModalCloseClick}
          activeUserObject={activeUserObject}
        />
      }
      <CommonToast 
      open={open}
      onClose={handleToastClose}
      content={content}
      iconType={iconType}
      bgColor={"#282D51"}
      />
    </div>
  );
};

export default CommonMoreActionOptionModal;
export { ViewTranscriptModal }
